module.exports = __webpack_public_path__ + "img/Female_Asia_Agent_W_Phone (1).ce19f6b.png";